module.exports = __webpack_public_path__ + "static/media/trace.85dd46ab.jpg";